import {Component, OnDestroy, OnInit} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";
import {TimeAgoPipe} from "../../../common/time-ago.pipe";
import * as _ from "lodash";
import {Constants} from "../../../constants";
import {GqlShopSessionService} from "../../../../checkout/graphql/shop-session/gql-shop-session.service";
import {interval, Subscription} from "rxjs";
import {map, switchMap} from "rxjs/operators";

@Component({
    selector: 'ssd-tab-realtime',
    templateUrl: './ssd-tab-realtime.component.html',
    styleUrls: ['./ssd-tab-realtime.component.scss', '../shop-session-dashboard-tab.scss'],
    standalone: false
})
export class SsdTabRealtimeComponent extends BaseComponent implements OnInit, OnDestroy {

    shopSessionRealtimeList: any;
    shopSessionCountryRealtimeList: any;
    recentShopSessions: any;
    enrollShopSessions: any;
    checkoutShopSessions: any;
    sessionTab: number;

    intervalSubscription: Subscription;
    activeTab: number = 0;

    intervalTime: number = -1;
    loading: boolean = false;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private timeAgo: TimeAgoPipe,
        private gqlShopSessionService: GqlShopSessionService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.getShopSessions().subscribe(() => {
            this.setShopSessions(0);
        });
    }

    startIntervalLogic() {
        this.stopIntervalLogic();
        if (this.intervalTime > 0) {
            this.getShopSessions().subscribe();
            this.intervalSubscription = interval(this.intervalTime).pipe(
                switchMap(() => this.getShopSessions())
            ).subscribe();
        }
    }

    stopIntervalLogic() {
        // Unsubscribe from the interval to stop it
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.stopIntervalLogic();
    }

    setActiveTab(tabIndex: number) {
        this.activeTab = tabIndex;
    }

    setShopSessions(sessionTab) {
        this.sessionTab = sessionTab;
    }

    getShopSessions() {
        this.loading = true;
        return this.gqlShopSessionService.getShopSessionDashboard().pipe(map((shopSessionDashboard: any) => {
            this.shopSessionRealtimeList = shopSessionDashboard.shopSessionRealtimeList;
            this.shopSessionCountryRealtimeList = shopSessionDashboard.shopSessionCountryRealtimeList;
            const recentShopSessions = shopSessionDashboard.recentShopSessions;
            const enrollShopSessions = shopSessionDashboard.enrollShopSessions;
            const checkoutShopSessions = shopSessionDashboard.checkoutShopSessions;

            this.updateSessions(this.recentShopSessions, recentShopSessions);
            this.updateSessions(this.enrollShopSessions, enrollShopSessions);
            this.updateSessions(this.checkoutShopSessions, checkoutShopSessions);

            this.recentShopSessions = recentShopSessions;
            this.enrollShopSessions = enrollShopSessions;
            this.checkoutShopSessions = checkoutShopSessions;

            this.loading = false;
        }));
    }

    updateSessions(currentShopSessions: any, newShopSessions: any) {
        this.markNewEvents(currentShopSessions, newShopSessions);
        this.updateDates(newShopSessions);
        this.setTimeoutToClearNewEvents(newShopSessions);
    }

    markNewEvents(currentShopSessions: any, newShopSessions: any) {
        //Got to mark the new things to highlight them!
        newShopSessions.forEach(newShopSession => {
            newShopSession.shopSessionEvents?.forEach(event => event.isNew = false);
        });

        if(currentShopSessions) {
            // Check for newly added shopSessionEvents and mark them as new
            newShopSessions.forEach(newShopSession => {
                const existingShopSession = currentShopSessions.find(oldShopSession => oldShopSession.shopSessionId === newShopSession.shopSessionId);
                newShopSession.totalEventsChanged = existingShopSession?.shopSessionEvents?.length != newShopSession.shopSessionEvents?.length;
                if (!existingShopSession) {
                    newShopSession.isNew = true;
                }
                if (existingShopSession) {
                    newShopSession.shopSessionEvents?.forEach(newEvent => {
                        const existingEvent = existingShopSession.shopSessionEvents?.find(event => event.shopSessionEventId === newEvent.shopSessionEventId);
                        if (!existingEvent) {
                            newEvent.isNew = true;
                        }
                    });
                }
            });
        }

        // Add some extra totals data to the shopSessions
        newShopSessions.forEach(shopSession => {
            shopSession.recentEventDate = shopSession.shopSessionEvents[0]?.createDate;
            shopSession.pendingOrders = _.filter(shopSession.shopSessionEvents, ["eventType", Constants.SHOP_SESSION_EVENT_TYPE_PENDING_ORDER])?.length;
            shopSession.enrollments = _.filter(shopSession.shopSessionEvents, ["eventCategory", Constants.SHOP_SESSION_EVENT_CATEGORY_ENROLL])?.length;
        });
    }

    updateDates(shopSessions: any) {
        if(shopSessions) {
            shopSessions?.forEach((session) => {
                session.recentEventDateTimeAgo = this.timeAgo.transform(session.recentEventDate);
                session.createDateTimeAgo = this.timeAgo.transform(session.createDate);
                if (session.shareable) {
                    session.shareable.createDateTimeAgo = this.timeAgo.transform(session.shareable?.createDate);
                }
                session.shopSessionEvents?.forEach((event: any) => {
                    event.createDateTimeAgo = this.timeAgo.transform(event.createDate);
                });
            });
        }
    }

    setTimeoutToClearNewEvents(shopSessions: any) {
        //to clear our highlighting after a few seconds
        setTimeout(() => {
            shopSessions.forEach(shopSession => {
                shopSession.totalEventsChanged = false;
                shopSession.isNew = false;
                shopSession.shopSessionEvents?.forEach(event => {
                    event.isNew = false;
                });
            });
        }, 3500);
    }

}
